import React from 'react';

type HamburgerIconProps = {
  className?: string;
  color?: string;
};

const HamburgerIcon: React.FC<HamburgerIconProps> = ({
  className = '',
  color = 'currentColor',
}) => {
  return (
    <svg
      width="64"
      height="26"
      viewBox="0 0 64 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <rect y="2" width="64" height="5" fill={color} />
      <rect y="17" width="64" height="5" fill={color} />
    </svg>
  );
};

export default HamburgerIcon;
